import { clsx } from 'clsx'

import { useHotkeysSettings } from '../../../common/hooks/useHotkeysSettings.js'
import { SectionTitle } from '../../../SmartSearch/components/SmartSearchResults/SectionTitle.js'
import { CommandBarActionType } from '../../types.js'

import { CommandBarActionItem } from './CommandBarActionItem.js'

type Props = {
  category: string
  actions: CommandBarActionType[]
  className?: string
}

export const CommandsSection = ({ category, actions, className }: Props) => {
  const { disabled: hotkeysDisabled } = useHotkeysSettings()

  return (
    <div className={clsx('pb-1', className)}>
      <SectionTitle title={category} view="command-bar" />

      <div className="px-2">
        {actions?.map(action => (
          <CommandBarActionItem
            key={`${action.category}-${action.name}-${action.url}`}
            action={action}
            hideHotkey={hotkeysDisabled}
          />
        ))}
      </div>
    </div>
  )
}
